const CrossFillGray = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9994 19.7176C16.2599 19.7176 19.7137 16.2638 19.7137 12.0033C19.7137 7.74287 16.2599 4.28906 11.9994 4.28906C7.73896 4.28906 4.28516 7.74287 4.28516 12.0033C4.28516 16.2638 7.73896 19.7176 11.9994 19.7176Z"
      fill="#707579"
    />
    <path
      d="M9.42969 9.42969L14.5725 14.5725M14.5725 9.42969L9.42969 14.5725"
      stroke="white"
      strokeWidth="1.54286"
      strokeLinecap="round"
    />
  </>
);

export default CrossFillGray;
